module.exports = __webpack_public_path__ + "img/fdm_logo.3fded8e2.png";